import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "../../../mocks/manga";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="bg-background-100" aria-labelledby="faq-heading">
      <div className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 text-center">
          <h2 id="faq-heading" className="font-display text-2xl text-foreground-950 md:text-3xl">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">关于妖精漫画网的使用疑问，这里都有答案</p>
        </div>

        <div className="space-y-3">
          {faqs.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <div key={item.q} className="overflow-hidden rounded-2xl border border-background-200/70 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : idx)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="text-sm font-medium text-foreground-950 md:text-base">{item.q}</h3>
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all ${open ? "bg-primary-100 text-primary-700" : "bg-background-100 text-foreground-500"}`}>
                    <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-sm`} aria-hidden="true"></i>
                  </span>
                </button>
                {open && (
                  <p className="border-t border-background-200/70 px-5 py-4 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>

        <p className="mt-8 text-center text-sm text-foreground-500">
          还有疑问？<Link to="/about" className="font-medium text-primary-600 hover:text-primary-700">前往关于我们</Link> 或
          <a href="mailto:hello@yaojingmanga.com" className="font-medium text-primary-600 hover:text-primary-700"> 联系我们</a>
        </p>
      </div>
    </section>
  );
}